import { FieldType, IEventMetadata, IFormFieldMetadata, IFormFieldValueMetadata, IFormMetadata, IFormSectionMetadata, IFormVersionMetadata, ISourceData, ISourceDataConfiguration, ISourceDataConfigurationEvent, ISourceDataConfigurationForm, ISourceDataConfigurationFormField, ISourceDataConfigurationFormFieldValue, ISourceDataConfigurationFormSection, ISourceDataConfigurationFormVersion, ISourceDataConfigurationSummary, ISourceDataEvent, ISourceDataField, ISourceDataForm, ISourceDataSummary, ITrialFormMetadata } from "@/api/dtos";
import { FC, RefObject } from "react";
import { IHasChildren } from '@ngt/forms';
import { VirtuosoHandle } from "react-virtuoso";
import { DateTime } from "luxon";


export enum PatientDataType {
    Configuration = 1,
    Snapshot = 2
}

export interface IPatientDataConfiguration {
    type: PatientDataType.Configuration;
    configuration?: ISourceDataConfigurationSummary;
}

export interface IPatientDataSnapshot {
    type: PatientDataType.Snapshot;
    configuration?: ISourceDataConfigurationSummary;
    snapshot?: ISourceDataSummary;
}

export type IPatientDataItem = IPatientDataConfiguration | IPatientDataSnapshot;

class PatientDataListProcessor {
    public processAll = async (configurations?: ISourceDataConfigurationSummary[]) => {
        const items: IPatientDataItem[] = [];

        // items.push({
        //     type: PatientDataType.Configuration
        // })

        // items.push({
        //     type: PatientDataType.Snapshot
        // })

        // for (let summary of summaries?.filter(x => !configurations?.some(y => y.id === x.sourceDataConfigurationId)) ?? []) {
        //     items.push({
        //         type: PatientDataType.Snapshot,
        //         snapshot: summary
        //     })
        // }

        for (let configuration of configurations ?? []) {
            items.push({
                type: PatientDataType.Configuration,
                configuration: configuration
            });
        }

        return items;
    }
}

export default PatientDataListProcessor;